export const environment = {
  //SSO APIs
  SSOauthAPI: "https://ppapi.auth.myzpax.com/api",
  ssoUserInfoAPI: "https://ppapi.auth.myzpax.com/connect/userinfo",
  ssoConnectAPI: "https://ppapi.auth.myzpax.com/connect/authorize",
  ssoLogoutAPI: "https://ppapi.auth.myzpax.com/api/account/logout",
  ssoLoginUrl: "https://preprod.auth.myzpax.com/sso/login",

  zpaxEsignatureDocumentRedirectEndPoint: "https://preprod.myzpax.com/app/document-signature/documents",
  zpaxChangepasswordEndpoint:"https://preprod.myzpax.com/user/password-and-security",
  zpaxPrivacyPolicyEndPoint: "https://preprod.myzpax.com/privacy.html",
  zpaxTermsEndPoint: "https://preprod.myzpax.com/terms.html",

  endpoint: "https://ppapi.rehabconnect.com/api/v1",
  sessionEncryptionKey:
    "fCCmUMuOM0kuDCuLe7naPOo6sNvlhXshFhZEVomw5XAS9vR7M0YGxbeaeYhiNmOC",
  idleTimeBeforeLocking: 1800,
  idleTimeBeforeTerminating: 2400,
  clientId: "8j57whgwfxxbchz4bj5cqcvueolyuwzt",
  userDetailsAPI: "/user/get",
  authorizationAPI: "/authorization",
  AWS_REGION: "us-east-1",
  AWS_ACCESS_KEY_ID: "",
  AWS_SECRET_ACCESS_KEY: "",
  AWS_SESSION_TOKEN: "",
  biDashboardSupersetDomain : 'https://4df6a8e3.us2a.app.preset.io',

  /**Matomo Analytics*/
  enableMatomo: false,
  matomo: {
    trackerUrl: "https://sandbox.matomo.z-pax.com/",
    siteId: 4
  },

  /**Pagesense */
  enablePagesense: false,
  pagesenseUrl: "https://cdn.pagesense.io/js/rehabconnectllc/b4f58c20f6384385a840cbf314bb6653.js",

  enableNewReactApp: false,
  postMessageTargets: ['https://preprod.myzpax.com'],
  supportEmail: 'support@rehabconnect.com',

  /** CMI Connect Therapy Referrals iframe*/
  therapyReferralUrl:
    "https://ppapi.auth.myzpax.com/connect/authorize?client_id=cmi_connect&redirect_uri=https%3A%2F%2Fpreprod.cmiconnect.com%2Fdashboard?embed=therapy&response_type=code&scope=offline_access%20email%20profile&fallback_uri=https%3A%2F%2Fz-pax.com%2Fcmi-connect&prompt=none",
  /** "Open full app" target for the Therapy Referrals embed - launches CMI Connect through the MyZPAX portal directly, outside the iframe. */
  therapyReferralFullAppUrl: "https://preprod.myzpax.com/connect",
};
